import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/imgcaptions/ttssel.png'
import _imports_1 from '@/assets/imgcaptions/ttsselNo.png'
import _imports_2 from '@/assets/imgcaptions/selOff.png'
import _imports_3 from '@/assets/imgcaptions/selOn.png'
import _imports_4 from '@/assets/imgcaptions/ttsDownNo.png'
import _imports_5 from '@/assets/imgcaptions/ttsLoad.png'
import _imports_6 from '@/assets/imgcaptions/ttsToDown.png'
import _imports_7 from '@/assets/imgcaptions/icon_jcguize.png'


const _hoisted_1 = { class: "pageTop" }
const _hoisted_2 = { class: "pageCenter" }
const _hoisted_3 = { class: "pageRow" }
const _hoisted_4 = { class: "pageRowRight" }
const _hoisted_5 = { class: "pageSel" }
const _hoisted_6 = {
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = {
  key: 0,
  class: "pageSel"
}
const _hoisted_8 = {
  src: _imports_0,
  alt: ""
}
const _hoisted_9 = { class: "pageRow" }
const _hoisted_10 = { class: "pageRowRight" }
const _hoisted_11 = { class: "pageSel" }
const _hoisted_12 = {
  src: _imports_0,
  alt: ""
}
const _hoisted_13 = { class: "pageSel" }
const _hoisted_14 = {
  src: _imports_0,
  alt: ""
}
const _hoisted_15 = { class: "pageRow" }
const _hoisted_16 = { class: "pageRowRight" }
const _hoisted_17 = { class: "pageSWitch" }
const _hoisted_18 = { class: "pageRow" }
const _hoisted_19 = { class: "pageRowRight" }
const _hoisted_20 = { class: "pageSWitch" }
const _hoisted_21 = {
  key: 0,
  class: "pageRow"
}
const _hoisted_22 = { class: "pageRowRight" }
const _hoisted_23 = { class: "pageSWitch" }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "pageRow" }
const _hoisted_26 = { class: "pageRowRight" }
const _hoisted_27 = { class: "pageSWitch" }
const _hoisted_28 = { class: "pageRow" }
const _hoisted_29 = { class: "pageBtm" }
const _hoisted_30 = { class: "pageBtmNoData" }
const _hoisted_31 = { class: "pageBtmList" }
const _hoisted_32 = { class: "titleOne" }
const _hoisted_33 = { class: "leftOne" }
const _hoisted_34 = { class: "leftOneTime" }
const _hoisted_35 = { class: "leftOneTxt" }
const _hoisted_36 = { class: "rightOne" }
const _hoisted_37 = { class: "runState" }
const _hoisted_38 = { class: "finishState" }
const _hoisted_39 = ["onClick"]

import {
    ArrowDown,
    ArrowUp,
    Delete,
    Close,
} from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import { ref, onMounted ,getCurrentInstance} from 'vue'
// 时间处理方法
import { timedataYmd, timedataHm ,timeInfo} from '@/components/public-method/time-method';
import {captionTtsStore} from "@/store/captionTts.ts"
import  ttsExportApi  from '@/api/newCaption/ttsExport.ts'
import { useRoute } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'ttsDown',
  emits: ['onInputFun','closeDown'],
  setup(__props, { emit: __emit }) {

let { proxy } = getCurrentInstance()
// 引入store
const ttstore=captionTtsStore()
// 引入接口
const route=useRoute()
// 参数
const exportType=ref('cn')//导出内容
const fusionSound=ref(false)
const ttsList=ref({})
const ttsListArray=ref([])
const haveTranslat=ref(false)// 是否有译文
const selRange=ref('全篇')
const selRoleList=ref([])// 选择角色列表 
const selRoleThis=ref('')// 选择角色 当前 
const fileName=ref('')// 文件名
const audioFormat=ref(true) // 音频格式 整体 分条 
const pageNum=ref(1)
const pageSize=ref(50) 
const total=ref(0) 
const selrangeFun=(e:any)=>{
    selRange.value=e.target.value
}
onMounted(()=>{
    haveTranslat.value=ttstore.isHaveTranslation
    selRoleList.value=ttstore.roleList
    console.log('角色列表')
    console.log(selRoleList.value)  
    const subtitleId=route.query.subtitleId
    getTtsDownList(subtitleId,pageNum.value,pageSize.value)
})
// 获取下载列表
const getTtsDownList=(subtitleId:any,pageNum:number,pageSize:number)=>{
    ttsExportApi.getList(subtitleId,pageNum,pageSize).then((res:any)=>{
        console.log(res)
        console.log(groupByTimestamp(res.rows))
        ttsListArray.value=res.rows
        ttsList.value=groupByTimestamp(res.rows)
        total.value=res.total
    }).catch((err:any)=>{
        console.log(err)      
    })
}  
// 
// 滚动加载
const scrollFun= () => {
    if(total.value==pageSize.value){
        pageNum.value+=1
    }else{
        return
    }
    const subtitleId=route.query.subtitleId
    ttsExportApi.getList(subtitleId,pageNum.value,pageSize.value).then((res:any)=>{
        console.log(res)
        console.log(groupByTimestamp(res.rows))
        ttsListArray.value=ttsListArray.value.concat(res.rows)
        ttsList.value=groupByTimestamp(ttsListArray.value)
    }).catch((err:any)=>{
        console.log(err)      
    })
} 
// 格式化时间戳为日期字符串
const formatTimestamp = (timestamp, format = 'YYYY-MM-DD') => {
  const date = new Date(timestamp);
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
}

// 分组函数
function groupByTimestamp(data, timestampKey = 'createTime') {
  return data.reduce((acc, item) => {
    const dateKey = formatTimestamp(item[timestampKey], 'YYYY-MM-DD');
    
    if (!acc[dateKey]) {
      acc[dateKey] = [];
    }
    acc[dateKey].push(item);
    return acc;
  }, {});
}
let emit=__emit
const onInput=()=>{
    emit('onInputFun',true)
}
const outInput=()=>{            
    emit('onInputFun',false)
}
// 下载
const downTts=(data:any)=>{
    console.log('下载TTs')
    console.log(data.fileUrl)
    let url='https://vp123.oss-cn-beijing.aliyuncs.com/'+data.fileUrl
    let filename=data.filename
    console.log(url)
    // const fileURL = window.URL.createObjectURL(url); // 创建了

    // const link = document.createElement('a'); // 创建一个链接元素开

    // link.href = fileURL;
    // // link.download = props.titleText.split('.')[0] + '.' + Filename.value.split('.')[1];
    // link.download = data.filename+ '.wav' ;
    // link.click(); // 拟点击下载链接
    // window.URL.revokeObjectURL(fileURL);
    if(filename.indexOf('wav')>0){
        filename=filename+'.wav'

    }
    const a = document.createElement('a');
    a.href = url;
    a.download = data.filename || 'downloaded-file';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
// 关闭tts下载页面
const closeTTsDown=()=>{
    emit('closeDown')
}
// 新增导出任务
const addExportFun=()=>{
    if(fileName.value==''){
        ElMessage.warning('请填写文件名')
        return
    }
    const subtitleId=route.query.subtitleId
    let data={
        subtitleId:subtitleId,
        textId:ttstore.textId,
        content:exportType.value=='cn'?1:2,//“导出内容 1.原文 2.译文")
        scope:selRange.value=='全篇'?1:2,//"导出范围 1.全篇 2.角色")
        roleId:selRoleThis.value,
        filename:fileName.value,
        backgroundSound:fusionSound.value?1:0,//"是否融合背景音 0.不融合 1.融合")
        audioFormat:audioFormat.value?"1":"2"//"音频格式 1.整体 2.分条")
    }
    if(selRange.value=='全篇'){
        delete data.roleId
    }  
    if(!audioFormat.value){
        delete data.backgroundSound 
    }
    console.log(data)
    ttsExportApi.addExport(data).then((res:any)=>{
        // console.log('新增导出任务')
        // console.log(res)
        if(res.code==200){
            pageNum.value=1
            pageSize.value=50
            getTtsDownList(subtitleId,pageNum.value,pageSize.value)
        }
    }).catch((err:any)=>{
        console.log(err)      
    })
}
//  接受推送消息
onMounted(() => {
    proxy.$ws.onmessageCaption = (message: any) => {
        console.log(message)
        if(ttstore.textId==message.textId ){
            const subtitleId=route.query.subtitleId
            pageNum.value=1
            pageSize.value=50
            getTtsDownList(subtitleId,pageNum.value,pageSize.value)
        }
        
    }
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ttsDownPage",
    onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "pageTopTitle" }, "导出幻音音频", -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_el_icon, {
          onClick: _withModifiers(closeTTsDown, ["stop"])
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "pageRowTitle" }, "导出内容", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
              [_vShow, exportType.value=='cn']
            ]),
            _withDirectives(_createElementVNode("img", {
              src: _imports_1,
              alt: "",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (exportType.value = 'cn'), ["stop"]))
            }, null, 512), [
              [_vShow, exportType.value=='en']
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("span", null, "原文", -1))
          ]),
          (haveTranslat.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
                  [_vShow, exportType.value=='en']
                ]),
                _withDirectives(_createElementVNode("img", {
                  src: _imports_1,
                  alt: "",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (exportType.value = 'en'), ["stop"]))
                }, null, 512), [
                  [_vShow, exportType.value=='cn']
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("span", null, "译文", -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "pageRowTitle" }, "音频格式", -1)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
              [_vShow, audioFormat.value]
            ]),
            _withDirectives(_createElementVNode("img", {
              src: _imports_1,
              alt: "",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (audioFormat.value = true), ["stop"]))
            }, null, 512), [
              [_vShow, !audioFormat.value]
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("span", null, "整体", -1))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [
              [_vShow, !audioFormat.value]
            ]),
            _withDirectives(_createElementVNode("img", {
              src: _imports_1,
              alt: "",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (audioFormat.value = false), ["stop"]))
            }, null, 512), [
              [_vShow, audioFormat.value]
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("span", null, "分条", -1))
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_15, [
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "pageRowTitle" }, "融合背景音", -1)),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("img", {
              src: _imports_2,
              alt: "",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (fusionSound.value = true), ["stop"]))
            }, null, 512), [
              [_vShow, !fusionSound.value]
            ]),
            _withDirectives(_createElementVNode("img", {
              src: _imports_3,
              alt: "",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (fusionSound.value = false), ["stop"]))
            }, null, 512), [
              [_vShow, fusionSound.value]
            ])
          ])
        ])
      ], 512), [
        [_vShow, audioFormat.value]
      ]),
      _createElementVNode("div", _hoisted_18, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "pageRowTitle" }, "导出范围", -1)),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("select", {
              class: "pageSelect",
              onChange: _cache[6] || (_cache[6] = ($event: any) => (selrangeFun($event))),
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selRange).value = $event))
            }, _cache[19] || (_cache[19] = [
              _createElementVNode("option", { value: "全篇" }, "全篇", -1),
              _createElementVNode("option", { value: "角色" }, "角色", -1)
            ]), 544), [
              [_vModelSelect, selRange.value]
            ])
          ])
        ])
      ]),
      (selRange.value=='角色')
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "pageRowTitle" }, "选择角色", -1)),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("select", {
                  class: "pageSelect",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selRoleThis).value = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selRoleList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: item.id,
                      key: index
                    }, _toDisplayString(item.name), 9, _hoisted_24))
                  }), 128))
                ], 512), [
                  [_vModelSelect, selRoleThis.value]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "pageRowTitle" }, "文件名", -1)),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "pageInput",
              onFocus: onInput,
              onBlur: outInput,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((fileName).value = $event))
            }, null, 544), [
              [_vModelText, fileName.value]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", {
          class: "pageRowBtn",
          onClick: _withModifiers(addExportFun, ["stop"])
        }, "生成导出任务")
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _withDirectives(_createElementVNode("div", _hoisted_30, _cache[23] || (_cache[23] = [
        _createElementVNode("img", {
          src: _imports_4,
          alt: ""
        }, null, -1),
        _createElementVNode("span", null, "没有任何导出任务", -1)
      ]), 512), [
        [_vShow, ttsListArray.value.length==0]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_31, [
        _createVNode(_component_el_scrollbar, {
          height: "100%",
          onScroll: scrollFun
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ttsList.value, (item, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "BtmListOne",
                key: key
              }, [
                _createElementVNode("div", _hoisted_32, _toDisplayString(key), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (it, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "rowOne",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(timedataHm)(it.createTime*1)), 1),
                      _createElementVNode("span", _hoisted_35, _toDisplayString(it.filename), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _withDirectives(_createElementVNode("div", _hoisted_37, _cache[24] || (_cache[24] = [
                        _createElementVNode("img", {
                          src: _imports_5,
                          alt: ""
                        }, null, -1),
                        _createElementVNode("span", null, "生成中…", -1)
                      ]), 512), [
                        [_vShow, it.status<100]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_38, [
                        _cache[25] || (_cache[25] = _createElementVNode("img", {
                          src: _imports_6,
                          alt: "",
                          class: "outImg"
                        }, null, -1)),
                        _createElementVNode("img", {
                          src: _imports_7,
                          alt: "",
                          class: "overImg",
                          onClick: _withModifiers(($event: any) => (downTts(it)), ["stop"])
                        }, null, 8, _hoisted_39)
                      ], 512), [
                        [_vShow, it.status==100]
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            }), 128))
          ]),
          _: 1
        })
      ], 512), [
        [_vShow, ttsListArray.value.length>0]
      ])
    ])
  ]))
}
}

})